import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styles from "./AdminFolder.module.css";
import { AxiosInstance } from "../../../../../../axios";
import toast from "react-hot-toast";
import Loader from "../../../../Loader";
import moment from "moment";

export default function AddFolderAdminInfo() {
  const { id, type } = useParams();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let user_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id not available in session storage");
  }
  const folderRef = useRef(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [initialfields, setInitialfields] = useState({
    id: "", // id value is required for edit
    folderName: "",
  });
  useEffect(() => {
    try {
      if (id) {
        const folderPayloadImage = {
          img_type: parseInt(type), // 1 for image, 0 for video
          is_admin: user_type === 1 ? 1 : 0, // 1 - admin, 0 - except admin
          page: "", // Empty to fetch all records
          page_size: "", // Empty to fetch all records
          folder_id: id,
        };
        AxiosInstance.post("/api/gallery/list", folderPayloadImage)
          .then((res) => {
            const folder_name = res.data.data[0];
            setInitialfields({
              folderName: folder_name.folder_name,
              id: folder_name.folder_id,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  }, []);
  const navigateToPreviousScreen = () => {
    if (id) {
      if (type == 1) {
        navigate(`/ViewImages/${id}`);
      } else {
        navigate(`/ViewVideos/${id}`);
      }
    } else {
      if (type == 1) {
        navigate("/GalleryImages");
      } else {
        navigate("/GalleryVideos");
      }
    }
  };

  const validateFocusCommentSection = (COMSECFO) => {
    if (!COMSECFO.folderName) {
      folderRef.current.focus();
    }
  };
  const validateFields = (data) => {
    const errors = {};
    if (!data.folderName) {
      errors.folderName = "Please enter folder name";
    }
    validateFocusCommentSection(data);
    return errors;
  };
  const handleSave = () => {
    const err_bnh = validateFields(initialfields);
    if (Object.keys(err_bnh).length === 0) {
      try {
        if (id) {
          const updateCoures = {
            id: initialfields.id,
            folder_name: initialfields.folderName,
            type: type,
            is_deleted: 0,
            created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid,
          };
          AxiosInstance.post(`api/gallery/add_folder`, updateCoures)
            .then((res) => {
              if (res.data.status) {
                toast.success(res.data.message);

                if (type == 0) {
                  navigate(`/GalleryVideos`);
                } else {
                  navigate(`/GalleryImages`);
                }
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              return error;
            });
        } else {
          const createCouresInfoData = {
            id: "",
            folder_name: initialfields.folderName,
            type: type,
            is_deleted: 0,
            created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid,
          };

          AxiosInstance.post(`api/gallery/add_folder`, createCouresInfoData)
            .then((res) => {
              if (res.data.status) {
                toast.success(res.data.message);
                if (type == 0) {
                  navigate(`/GalleryVideos`);
                } else {
                  navigate(`/GalleryImages`);
                }
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              return error;
            });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(err_bnh);
    }
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className={`${styles.GalleryInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">
            {id ? "Edit Folder" : "Add New Folder"}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigateToPreviousScreen();
                }}
                className="secondaryButton"
              >
                {id
                  ? type == 1
                    ? "Back to View Images"
                    : "Back to View Videos"
                  : type == 1
                  ? "Back to  Images"
                  : "Back to  Videos"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSave}
                className="primaryButton text-center"
              >
                Save Folder
              </Link>
            </li>
          </ul>
        </div>

        <div className="row m-0 mb-3">
          <fieldset className="mt-3">
            <legend className="w-auto">Folder Details</legend>
            <form className="row g-3">
              {/* Video Title */}
              <div className="col-md-6">
                <div className="form-group">
                  <label
                    htmlFor="CourseGrouping"
                    className="form-label confirm_value "
                  >
                    Folder Name
                  </label>
                  <input
                    ref={folderRef}
                    type="text"
                    className="desc_input_text w-100 rounded-2 input-font-size-sm py-2"
                    value={initialfields.folderName}
                    onChange={(e) =>
                      setInitialfields({
                        ...initialfields,
                        folderName: e.target.value,
                      })
                    }
                    placeholder="Enter the Folder name"
                    maxLength={500}
                  />
                  {error.folderName && (
                    <small className="error_message">{error.folderName}</small>
                  )}
                </div>
              </div>
            </form>
          </fieldset>
        </div>
        <div className="col-md-12 col-12 ListBtn pt-2">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/GalleryVideos"}
                onClick={id ? navigateToPreviousScreen : () => {}}
                className="secondaryButton"
              >
                {id
                  ? type == 1
                    ? "Back to View Images"
                    : "Back to View Videos"
                  : type == 1
                  ? "Back to  Images"
                  : "Back to  Videos"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSave}
                className="primaryButton text-center"
              >
                Save Folder
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
